module.exports = __webpack_public_path__ + "static/bsas001.thumb-0a401fe9b960af7dbb2853e242ba370c.jpg";